export const environment = {
  production: true,
  web_site: "https://app.studiomap.fr",
  is_webflow: false,
  api: "https://api.studiomap.fr/api",
  api_base_link: "https://api.studiomap.fr",
  stripe_pk: "pk_live_51IqzjML8SJyYJrpKnzUNAspWvqCNGSxfNvn0NLLEY6rEgtYYDMFYfNiLzPydfG46j4g3VZ672zk0TWBv3h3wzxHP00B4PFc1bZ",
  default_avatar : "assets/img/default.png",
  default_cover: "assets/img/cover.png",
  backend_passculture_pro: "backend.passculture.pro",
  stripe_dashboard_link : "https://dashboard.stripe.com",
  webflow_url: "https://www.studiomap.fr",
  passculture_link: "https://passculture.pro",
  PASSCULTURE_STRUCTURE_ID:13653,
  admin_url: "https://admin.studiomap.fr/#"
};
